var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("\n            View Payment\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }